import React from 'react';

import { useSelector } from 'react-redux';

import { ConferenceStatus } from '../../../pages/call/constants';
import { cancelCallAction } from '../../../pages/call/features/conference/slice';
import { getConferenceStatus, getJoinedAsGuest } from '../../../pages/call/selectors';
import { getAutoJoin } from '../../features/config/selectors';
import { i18n } from '../../helpers/i18n';
import { useActions } from '../../hooks';
import { useAppStoreLink } from '../../hooks/useAppStoreLink';
import Button from '../button';
import SvgImage from '../svg-image';
import css from './styles.css';

export function NativeAppBanner() {
    const joinedAsGuest = useSelector(getJoinedAsGuest);
    const autoJoin = useSelector(getAutoJoin);
    const conferenceStatus = useSelector(getConferenceStatus);
    const { canselCall } = useActions({ canselCall: cancelCallAction });

    const url = useAppStoreLink();

    const shouldHideBanner =
        !url ||
        !joinedAsGuest ||
        conferenceStatus === ConferenceStatus.JOINED ||
        (autoJoin && conferenceStatus === ConferenceStatus.JOINING);

    if (shouldHideBanner) {
        return null;
    }

    const handleBannerClick = () => {
        window.location.assign(url);

        if (conferenceStatus !== ConferenceStatus.DISCONNECTED) {
            canselCall({ skipFeedbackSaga: true });
        }
    };

    return (
        <div className={css.nativeAppBanner}>
            <SvgImage imageName="telemost" className={css.appIcon} />
            <div className={css.appDetails}>
                <div className={css.appName}>{i18n('native-app-banner', 'app-name')}</div>
                <div className={css.appDescription}>{i18n('native-app-banner', 'app-description')}</div>
            </div>
            <Button
                className={css.appOpenButton}
                elementType="a"
                href={url}
                onClick={handleBannerClick}
                size="md"
                view="brand"
            >
                {i18n('native-app-banner', 'app-open-button')}
            </Button>
        </div>
    );
}
